export interface IQuickEditFieldModel {
    identifier: string;
    /**
     * A list of optional sub fields
     */
    fields?: IQuickEditFieldModel[];
}

export class QuickEditFieldModel implements IQuickEditFieldModel {
    public identifier: string;
    public fields?: QuickEditFieldModel[];
    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IQuickEditFieldModel);
    constructor(obj?: any) {
        this.identifier = obj && obj.identifier || '';
        if (obj && obj.fields !== undefined) {
            this.fields = [];
            obj.fields.forEach((field: QuickEditFieldModel) => {
                this.fields!.push(new QuickEditFieldModel(field));
            });
        }
    }
}
